import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../../core/redux/action";
import { ArrowLeft, ChevronUp, Info } from "react-feather";
import { all_routes } from "../../../Router/all_routes";
import { useEffect } from "react";
import apiHandler from "../../common/api";
import { TagsInput } from "react-tag-input-component";
// import CommonTextEditor from "../../components/Editor/CommonTextEditor";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import { useLocation } from "react-router-dom";
import CustomeEditor from "../../components/Editor/CustomeEditor";

function NotificationMaster() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const userData = useSelector((state) => state.user_data);
  const navigate = useNavigate();
  const routes = all_routes;
  const notificationId = useParams()?.id || 0;

  const BusinessID = userData?.businessId;

  const location = useLocation();
  const isCloneMode =
    new URLSearchParams(location.search).get("clone") === "true";

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [formData, setFormData] = useState({
    id: 0,
    notificationUniqueName: "",
    emailSubject: "",
    emailCC: "",
    emailBody: "",
    emailIsActive: 0,
    smsIsActive: 0,
    // smsFrom: "",
    smsBody: "",
    whatsappIsActive: 0,
    // whatsappFrom: "",
    whatsappBody: "",
    notificationUniqueNameError: "",
    emailSubjectError: "",
    emailBodyError: "",
    smsBodyError: "",
    whatsappBodyError: "",
  });

  const [isReadOnly, setIsReadOnly] = useState(false);

  const [dynamicData, setDynamicData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [activeField, setActiveField] = useState("");

  const [cursorPos, setCursorPos] = useState({});

  const getActiveField = () => activeField || "smsBody"; // default fallback

  const handleFocus = (fieldName) => {
    setActiveField(fieldName);
  };

  // const [emailBody, setEmailBody] = useState("");

  // const getCustomerDetails = async (notificationId) => {
  //   const response = await apiHandler({
  //     method: "GET",
  //     route: `Superadmin/ModuleFindId?Module=notificationMaster&ID=${notificationId}`,
  //   });
  //   if (response.ResponseCode === "SUCCESS") {
  //     console.log(response, "data");
  //     setFormData({ ...response.ResponseData[0] });
  //     // setEmailBody(response.ResponseData[0]?.emailBody || "");
  //   } else {
  //     console.log(response, "data");
  //   }
  // };
  const getCustomerDetails = async (notificationId) => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/ModuleFindId?Module=notificationMaster&ID=${notificationId}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      let data = { ...response.ResponseData[0] };

      if (isCloneMode) {
        data.id = 0;
        data.businessID = BusinessID; // assign current business
        data.notificationUniqueName = ``;
        // data.notificationUniqueName = `${data.notificationUniqueName}_Copy`;
        navigate(`/notificationMaster`, { replace: true });
      }

      setFormData(data);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    if (
      notificationId > 0 &&
      formData?.notificationUniqueName?.trim() === "Marketing_Booster"
    ) {
      setIsReadOnly(true);
    }
  }, [notificationId, formData?.notificationUniqueName]);

  useEffect(() => {
    if (notificationId > 0) {
      getCustomerDetails(notificationId);
    }
  }, [notificationId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //   const handleCheckboxChange = (e) => {
  //     const { name, checked } = e.target;
  //     if (e) {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         [name]: checked,
  //       }));
  //     }
  //   };

  const handleSubmit = async (e) => {
    e.preventDefault();

     setFormData((prevState) => ({
    ...prevState,
    firstNameError: "",
    lastNameError: "",
  }));

  // Validate first name and last name
  let hasError = false;

  if (!formData.notificationUniqueName.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      notificationUniqueNameError: "Notification Unique Name is required.",
    }));
    hasError = true;
  }

  if (!formData.emailSubject.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      emailSubjectError: "Email Subject is required.",
    }));
    hasError = true;
  }

  if ((!formData.emailCC.trim() && formData.emailIsActive == 1)) {
    setFormData((prevState) => ({
      ...prevState,
      emailBodyError: "Email Content is required.",
    }));
    hasError = true;
  }

  if ((!formData.smsBody.trim() && formData.smsIsActive == 1)) {
    setFormData((prevState) => ({
      ...prevState,
      smsBodyError: "Sms Content is required.",
    }));
    hasError = true;
  }
  
  if ((!formData.whatsappBody.trim() && formData.whatsappIsActive == 1)) {
    setFormData((prevState) => ({
      ...prevState,
      whatsappBodyError: "whatsapp Content is required.",
    }));
    hasError = true;
  }

  if (hasError) {
    setLoading(false);
    return; // Stop the form submission if there's an error
  }

    setLoading(true);

    // Get selected dynamic content IDs from the content
    const extractDynamicContentIds = (text) => {
      const matches = text?.match(/#([^#]+)#/g) || [];
      return matches
        .map((match) => {
          const alias = match.replace(/#/g, "");
          const content = dynamicData[0]?.find((item) => item.Alias === alias);
          return content?.ID;
        })
        .filter(Boolean);
    };

    // Extract IDs from all content types
    const emailIds = extractDynamicContentIds(formData.emailBody);
    const smsIds = extractDynamicContentIds(formData.smsBody);
    const whatsappIds = extractDynamicContentIds(formData.whatsappBody);

    // Combine all IDs and remove duplicates
    const allDynamicIds = [
      ...new Set([...emailIds, ...smsIds, ...whatsappIds]),
    ].join(",");

    const response = await apiHandler({
      method: "POST",
      route: `Superadmin/notificationMasterUpsert`,
      payload: {
        ...formData,
        loginuserid: userData?.id,
        dynamicContentIds: allDynamicIds,
      },
    });
    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
      handleCancle();
    } else {
      setLoading(false);
      console.log(response, "data");
    }
  };

  const handleCancle = () => {
    navigate(routes.notificationList);
    setFormData({
      id: 0,
      notificationUniqueName: "",
      emailSubject: "",
      emailCC: "",
      emailBody: "",
      emailIsActive: 0,
      smsIsActive: 0,
      smsFrom: "",
      smsBody: "",
      whatsappIsActive: 0,
      whatsappFrom: "",
      whatsappBody: "",
    });
  };

  const getBusinessDetailById = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/getDynamicContent?BusinessID=${notificationId}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      setDynamicData(response?.ResponseData);
    }
  };

  useEffect(() => {
    getBusinessDetailById();
  }, []);

  const insertDynamicTag = (tagName, fieldName) => {
    const tag = tagName; // already "#NAME#"

    const cursorData = cursorPos[fieldName];
    if (!cursorData?.range) {
      // Append at end if cursor missing
      setFormData((prev) => ({
        ...prev,
        [fieldName]: (prev[fieldName] || "") + tag,
      }));
      return;
    }

    const range = cursorData.range;

    // Insert tag at caret
    range.deleteContents();
    const node = document.createTextNode(tag);
    range.insertNode(node);

    // Move cursor to after inserted tag
    range.setStartAfter(node);
    range.setEndAfter(node);

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    // Update parent form state
    setFormData((prev) => {
      const div = document.querySelector(`div[name="${fieldName}"]`);
      return {
        ...prev,
        [fieldName]: div?.innerHTML || "",
      };
    });
  };

  const handleCursorChange = ({ name, range }) => {
    setCursorPos((p) => ({
      ...p,
      [name]: { range },
    }));
  };

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="mt-5">
        <div className="page-wrapper  pt-0">
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>NotificationMaster</h4>
                  <h6>Manage NotificationMaster</h6>
                </div>
              </div>

              <ul className="table-top-head">
                <li>
                  <OverlayTrigger
                    placement="top"
                    overlay={renderCollapseTooltip}
                  >
                    <Link
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      id="collapse-header"
                      className={data ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(setToogleHeader(!data));
                      }}
                    >
                      <ChevronUp />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li>
                  <div className="page-btn">
                    <button
                      onClick={() => navigate(all_routes.notificationList)}
                      className="4 btn btn-primary btn-md btn-wave me-2"
                    >
                      <ArrowLeft className="me-2" />
                      Back to Notification List
                    </button>
                  </div>
                </li>
              </ul>
            </div>

            <div className="">
              <div className="">
                <div className="accordion" id="accordionPanelsStayOpenExample">
                  <div className="accordion-item show">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingOne"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne"
                      >
                        <div className="card-title-head">
                          <h6 className="m-0 p-0" style={{ border: "none" }}>
                            <span>
                              <Info className="feather-edit" />
                            </span>
                            Notification Master Information
                          </h6>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingOne"
                    >
                      <div className="accordion-body">
                        <div className="col-6">
                          <div className="row mb-3">
                            <div className="form-group col-12">
                              <label className="text-sm-medium">
                                Notification Unique Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="notificationUniqueName"
                                placeholder="Notification Unique Name"
                                value={formData.notificationUniqueName}
                                onChange={handleChange}
                                readOnly={notificationId > 0}
                              />
                              {formData.notificationUniqueNameError && (
                                <div className="text-danger">{formData.notificationUniqueNameError}</div>
                              )}
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="form-group col-12">
                              <label className="text-sm-medium">
                                Email Subjects
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="emailSubject"
                                placeholder="Email Subject"
                                value={formData.emailSubject}
                                onChange={handleChange}
                              />
                              {formData.emailSubjectError && (
                                <div className="text-danger">{formData.emailSubjectError}</div>
                              )}
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="form-group col-12">
                              <label className="text-sm-medium">
                                CC Mail: *
                              </label>
                              <TagsInput
                                value={
                                  formData.emailCC
                                    ? formData.emailCC.split(",")
                                    : []
                                }
                                onChange={(tags) =>
                                  setFormData({
                                    ...formData,
                                    emailCC: tags.join(","),
                                  })
                                }
                                name="ccEmail"
                                placeHolder="Press Enter to Add"
                              />
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="d-flex align-items-center form-group col-12 gap-2">
                              <label className="text-sm-medium">
                                Email IsActive
                              </label>
                              <input
                                className="custome-boder form-check-input"
                                type="checkbox"
                                name="emailIsActive"
                                checked={formData.emailIsActive === 1}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    emailIsActive: e.target.checked ? 1 : 0,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="d-flex align-items-center form-group col-12 gap-2">
                              <label className="text-sm-medium">
                                SMS IsActive
                              </label>
                              <input
                                className="custome-boder form-check-input"
                                type="checkbox"
                                name="smsIsActive"
                                checked={formData.smsIsActive === 1}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    smsIsActive: e.target.checked ? 1 : 0,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="d-flex align-items-center form-group col-12 gap-2">
                              <label className="text-sm-medium">
                                Whatsapp IsActive
                              </label>
                              <input
                                className="custome-boder form-check-input"
                                type="checkbox"
                                name="whatsappIsActive"
                                checked={formData.whatsappIsActive === 1}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    whatsappIsActive: e.target.checked ? 1 : 0,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          {formData.emailIsActive === 1 && (
                            <>
                              <div className="row mb-3">
                                <div className="form-group col-12">
                                  <label className="text-sm-medium">
                                    Email Body
                                  </label>
                                  <p>
                                    <strong>Note: </strong>Please do not edit
                                    the text between the forward{" "}
                                    <span className="text-danger">#</span> and
                                    backward{" "}
                                    <span className="text-danger">#</span>.
                                    Altering this text will affect the dynamic
                                    mail content and may prevent the dynamic
                                    content from being properly fetched in the
                                    email.
                                  </p>
                                  <CustomeEditor
                                    value={formData?.emailBody || ""}
                                    name="emailBody"
                                    isReadOnly={isReadOnly}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        emailBody: e?.target?.value || "",
                                      });
                                    }}
                                    onFocus={() => handleFocus("emailBody")}
                                    onCursorChange={handleCursorChange}
                                  />
                                  {formData.emailBodyError && (
        <div className="text-danger">{formData.emailBodyError}</div>
      )}
                                </div>
                              </div>
                              <hr />
                            </>
                          )}
                          {formData.smsIsActive === 1 && (
                            <>
                              <div className="row mb-3">
                                <div className="form-group col-12">
                                  <label className="text-sm-medium">
                                    SMS Body
                                  </label>
                                  <p>
                                    <strong>Note: </strong>Please do not edit
                                    the text between the forward{" "}
                                    <span className="text-danger">#</span> and
                                    backward{" "}
                                    <span className="text-danger">#</span>.
                                    Altering this text will affect the dynamic
                                    mail content and may prevent the dynamic
                                    content from being properly fetched in the
                                    sms.
                                  </p>
                                  {/* <textarea
  className="form-control"
  name="smsBody"
  placeholder="SMS Body"
  value={formData.smsBody || ""}
  onChange={handleSmsChange}
  onFocus={() => handleFocus("smsBody")}
  style={{ minHeight: "200px" }}
  disabled={isReadOnly}
/> */}

                                  <CustomeEditor
                                    value={formData?.smsBody || ""}
                                    name="smsBody"
                                    isReadOnly={isReadOnly}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        smsBody: e?.target?.value || "",
                                      });
                                    }}
                                    onFocus={() => handleFocus("smsBody")}
                                    onCursorChange={handleCursorChange}
                                  />
                                   {formData.smsBodyError && (
        <div className="text-danger">{formData.smsBodyError}</div>
      )}

                                  {/* onChange={(e) => {
                                       if (e.target.value.length <= 300) {
                                         handleChange(e);
                                       }
                                     }} */}
                                  {/* <div className="text-end text-muted small mt-1">
                                    {formData.smsBody.length}/300 characters
                                  </div> */}
                                </div>
                              </div>
                              <hr />
                            </>
                          )}
                          {formData.whatsappIsActive === 1 && (
                            <div className="row mb-3">
                              <div className="form-group col-12">
                                <label className="text-sm-medium">
                                  Whatsapp Body
                                </label>
                                <p>
                                  <strong>Note: </strong>Please do not edit the
                                  text between the forward{" "}
                                  <span className="text-danger">#</span> and
                                  backward{" "}
                                  <span className="text-danger">#</span>.
                                  Altering this text will affect the dynamic
                                  mail content and may prevent the dynamic
                                  content from being properly fetched in the
                                  whatsapp.
                                </p>
                                {/* <textarea
                                  className="form-control"
                                  type="text"
                                  name="whatsappBody"
                                  placeholder="Whatsapp Body"
                                  value={formData.whatsappBody}
                                  onChange={handleChange}
                                  //                                   onChange={(e) => {
                                  //   if (e.target.value.length <= 300) {
                                  //     handleChange(e);
                                  //   }
                                  // }}
                                  //                                 onFocus={() => handleFocus("whatsappBody")}
                                  style={{ minHeight: "200px" }}
                                  disabled={isReadOnly}
                                /> */}

                                <CustomeEditor
                                  value={formData?.whatsappBody || ""}
                                  name="smsBody"
                                  isReadOnly={isReadOnly}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      whatsappBody: e?.target?.value || "",
                                    });
                                  }}
                                  onFocus={() => handleFocus("whatsappBody")}
                                  onCursorChange={handleCursorChange}
                                />
                                 {formData.whatsappBodyError && (
        <div className="text-danger">{formData.whatsappBodyError}</div>
      )}
                                {/* <div className="text-end text-muted small mt-1">
                                  {formData.smsBody.length}/300 characters
                                </div> */}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="dynamic-side-section">
                          <h4>Dynamic Data</h4>
                          <div className="dynamic-data-list">
                            {dynamicData[0]?.map((item) => (
                              <div
                                key={item.ID}
                                className="data-item"
                                onClick={() =>
                                  insertDynamicTag(item.Name, getActiveField())
                                }
                                title={`Insert ${item.Name}`}
                              >
                                <span className="data-alias">{item.Alias}</span>
                                <span className="data-name">{item.Name}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Add Action Buttons */}
                <div className="col-lg-12 col-md-12 col-12 mt-4">
                  <div className="btn-addproduct mb-4">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-md me-2"
                      onClick={handleCancle}
                    >
                      Cancel
                    </button>

                    <button
                      className="3 btn btn-primary btn-md btn-wave me-2"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotificationMaster;
